var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":_vm.label,"color":_vm.color,"input-value":_vm.inputValue,"indeterminate":_vm.indeterminate},on:{"click":_vm.atualizar}})
}
var staticRenderFns = []

export { render, staticRenderFns }